// Common validation utilities

export const properCase = (str) => (str || '')
  .toLowerCase()
  .split(/([\s\-'\.])/)
  .map((seg) => (/^[a-z]/.test(seg) ? seg.charAt(0).toUpperCase() + seg.slice(1) : seg))
  .join('');

// UK mobile: 07XXX XXXXXX (11 digits starting with 07)
// UK landline: 01/02XX XXXXXXX (10-11 digits starting with 01 or 02) plus 03
// International prefix +44
export const validateUKPhone = (raw) => {
  const clean = (raw || '').replace(/[^0-9+]/g, '');
  if (!clean) return { ok: false, error: 'Phone number is required' };

  let digits = clean.startsWith('+44') ? '0' + clean.slice(3) : clean.startsWith('0044') ? '0' + clean.slice(4) : clean;
  if (!/^0[1237]/.test(digits)) return { ok: false, error: 'Enter a valid UK number (starting 01, 02, 03 or 07)' };
  if (digits.length < 10 || digits.length > 11) return { ok: false, error: 'UK phone numbers are 10–11 digits long' };

  // Reject repeated digits like 0777777777, 07123456789 sequential, 0712345678, 07000000000
  const body = digits.slice(2);
  if (/^(\d)\1+$/.test(body)) return { ok: false, error: 'That looks like a placeholder number' };
  if (body === '123456789' || body === '1234567890') return { ok: false, error: 'That looks like a placeholder number' };

  // Common test/dummy numbers
  const dummy = ['07000000000', '07777777777', '07111111111', '07123456789', '01234567890', '02000000000'];
  if (dummy.includes(digits)) return { ok: false, error: 'That looks like a dummy number' };

  const kind = digits.startsWith('07') ? 'Mobile' : 'Landline';
  return { ok: true, formatted: digits, kind };
};

// UK postcode format check
export const validateUKPostcode = (raw) => {
  const clean = (raw || '').toUpperCase().replace(/\s+/g, '');
  const pattern = /^([A-Z]{1,2}\d[A-Z\d]?)\d[A-Z]{2}$/;
  if (!pattern.test(clean)) return { ok: false, error: 'Enter a valid UK postcode' };
  const formatted = clean.slice(0, -3) + ' ' + clean.slice(-3);
  return { ok: true, formatted };
};

// Disposable email domains (partial common list)
const DISPOSABLE = new Set([
  'mailinator.com', 'guerrillamail.com', '10minutemail.com', 'tempmail.com', 'temp-mail.org',
  'yopmail.com', 'trashmail.com', 'throwaway.email', 'getnada.com', 'sharklasers.com',
  'maildrop.cc', 'dispostable.com', 'mohmal.com', 'fakeinbox.com', 'mytemp.email',
  'spam4.me', 'moakt.com', 'emailondeck.com', 'tempail.com', 'burnermail.io',
  'mailnesia.com', 'dropmail.me', 'anonaddy.com', 'inboxbear.com', 'temp-inbox.me',
]);

export const validateEmail = (raw) => {
  const email = (raw || '').trim().toLowerCase();
  if (!email) return { ok: false, error: 'Email is required' };
  const pattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
  if (!pattern.test(email)) return { ok: false, error: 'Enter a valid email address' };
  const domain = email.split('@')[1];
  if (DISPOSABLE.has(domain)) return { ok: false, error: 'Disposable and temporary email addresses are not allowed' };
  return { ok: true, formatted: email };
};

export const generateOTP = () => String(Math.floor(100000 + Math.random() * 900000));
